import { render } from "./CardPageVisits.vue?vue&type=template&id=5cfcf1d6"
const script = {}

import exportComponent from "C:\\xampp\\htdocs\\vue-notus-main\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__